import { ButtonDropdown, Link } from '@cloudscape-design/components';
import { findInNavGraph } from 'src/utils/findInNavGraph';
import { ArtifactCard } from 'src/components/ArtifactsSection';
import { useRecentlyViewed } from 'src/components/providers/RecentlyViewedProvider';
import { useNavGraph } from 'src/components/providers/NavGraphProvider';
import { useFavorites } from 'src/components/providers/FavoritesProvider';
import { useTranslate } from 'src/i18n/useTranslate';
import './artifact-card-header.scss';
export type ArtifactListCardProps = {
    item: ArtifactCard;
    testId: string;
};
const ArtifactCardHeader = ({ item, testId }: ArtifactListCardProps) => {
    const t = useTranslate();
    const { addRecentlyViewed } = useRecentlyViewed();
    const { navGraph } = useNavGraph();
    const { addFavorite, deleteFavorite, isFavorite } = useFavorites();

    const getImageUrl = (id: number, path: string | undefined) => {
        if (!path) return '';
        const document = findInNavGraph(id, path, navGraph, 'id');
        return document?.pictureUrl || '';
    };

    const handleTitleOnFollow = (item: ArtifactCard) => {
        if (item.externalUrl) {
            addRecentlyViewed(item.id);
        }
    };
    return (
        <div data-list-page-card data-testid={testId}>
            <div className="artifact-card-header-title-info">
                <img
                    alt={item.description}
                    src={getImageUrl(item.id, item.breadcrumbPath)}
                    style={{
                        width: '50px',
                        marginRight: '20px',
                    }}
                    onError={(e) => {
                        e.currentTarget.style.display = 'none';
                    }}
                />
                <Link
                    href={
                        item.externalUrl
                            ? item.externalUrl.replace('http://', 'https://')
                            : `/${item.id}`
                    }
                    onFollow={(e) => {
                        if (!item.externalUrl) {
                            e.preventDefault();
                            window.location.href = `/${item.id}`;
                        }
                        handleTitleOnFollow(item);
                    }}
                    target={item.externalUrl ? '_blank' : '_self'}
                    fontSize="heading-m"
                >
                    {item.title}
                </Link>
            </div>
            <ButtonDropdown
                onItemClick={({ detail }) => {
                    const id = detail.id;

                    switch (id) {
                        case 'favorite':
                            deleteFavorite(item.id);
                            break;
                        case 'not-favorite':
                            addFavorite(item.id);
                            break;
                        case 'copy-link':
                            navigator.clipboard.writeText(
                                `${window.location.origin}/${item.id}`
                            );
                            break;

                        default:
                            break;
                    }
                }}
                data-list-page-card-dropdown-container
                data-testid={'article-button-dropdown'}
                items={[
                    {
                        id: 'copy-link',
                        text: t('landing_page_card_options_copy', 'Copy link'),
                        iconName: 'copy',
                    },
                    {
                        id: isFavorite(item.id) ? 'favorite' : 'not-favorite',
                        text: isFavorite(item.id)
                            ? t(
                                  'remove-from-favorites',
                                  'Remove from Favorites'
                              )
                            : t('add-to-favorites', 'Add to Favorites'),
                        iconName: 'heart',
                    },
                ]}
                ariaLabel={t('control_instance', 'Control instance')}
                variant="inline-icon"
            />
        </div>
    );
};

export default ArtifactCardHeader;
